// extracted by mini-css-extract-plugin
module.exports = {"subtitle":"TimeSlotSelector_subtitle__AYIWm"};